import React, { useState, useEffect } from "react";
import CategoryCard from "./CategoryCard";
import RaceGrid from "./RaceGrid";
import BetSelector from "./BetSelector";
import { getRaceById } from "../services/GridServices";
import { getAllCategories } from "../services/CategoryCardServices";
import "./JoinRaces.css";

const JoinRaces = () => {
  const [selectedRaceType, setSelectedRaceType] = useState("all");
  const [showBetSelector, setShowBetSelector] = useState(false);
  const [selectedRaceData, setSelectedRaceData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoryData = await getAllCategories();
        setCategories(categoryData);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleShowBetSelector = async (raceId) => {
    try {
      const raceData = await getRaceById(raceId);
      setSelectedRaceData(raceData);
      setShowBetSelector(true);
      document.body.style.overflow = "hidden";
    } catch (error) {
      console.error("Error fetching race data:", error);
    }
  };

  const handleCloseBetSelector = () => {
    setShowBetSelector(false);
    setSelectedRaceData(null);
    document.body.style.overflow = "unset";
  };


  const handleCategoryBet = (type) => {
    setSelectedRaceType(type);
    // Scroll to race grid
    document
      .getElementById("race-grid")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading races...</p>
      </div>
    );
  }

  return (
    <div className="join-races-container">
      {/* Categories Section */}
      <div className="gap-4 mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((category) => (
          <CategoryCard
            key={category.id}
            title={category.title}
            description={category.description}
            gradient={category.gradient}
            icon={category.icons}
            timer={category.timer}
            stats={category.stats}
            onPlaceBet={() => handleCategoryBet(category.type)}
          />
        ))}
      </div>

      {/* Controls and Race Grid */}
      <div
        className={`main-content ${showBetSelector ? "blur-background" : ""}`}
      >
        <div className="py-3">
          <div className="race-type-filters">
            <button
              className={`filter-button ${selectedRaceType === "all" ? "active" : ""
                }`}
              onClick={() => setSelectedRaceType("all")}
            >
              All Races
            </button>
            {categories.map((category) => (
              <button
                key={category.id}
                className={`filter-button ${selectedRaceType === category.type ? "active" : ""
                  }`}
                onClick={() => setSelectedRaceType(category.type)}
              >
                {category.title}
              </button>
            ))}
          </div>
        </div>

        <div id="race-grid">
          <RaceGrid
            viewMode={"grid"}
            raceType={selectedRaceType}
            onPlaceBet={handleShowBetSelector}
          />
        </div>
      </div>

      {/* Bet Selector Modal */}
      {showBetSelector && selectedRaceData && (
        <BetSelector
          onClose={handleCloseBetSelector}
          raceData={selectedRaceData}
        />
      )}
    </div>
  );
};

export default JoinRaces;
